@if (!isLoading) {
  <!-- Single Archive Result Set: Show just a button. -->
  @if (archiveSets === 'single') {
    <button mat-button [matTooltip]="taskSearch.archives[0].name">
      @if ((isHandset$ | async) === false) {
        <span style="margin-left: 5px">{{ taskSearch.archives[0].name }}</span>
      }
    </button>
  }
  @if (archiveSets === 'multi') {
    <button
      mat-button
      [matTooltip]="archive.name"
      [matMenuTriggerFor]="archiveSelectMenu"
    >
      <mat-icon
        [matBadge]="archive.processCount"
        matBadgePosition="above before"
        >expand_circle_down</mat-icon
      >
      @if ((isHandset$ | async) === false) {
        <span style="margin-left: 5px">{{ archive.name }}</span>
      }
    </button>
  }
  <mat-menu #archiveSelectMenu="matMenu">
    <ng-template matMenuContent>
      @for (taskArchive of taskSearch.archives; track taskArchive) {
        @if (taskArchive.id !== archive.id) {
          <button mat-menu-item (click)="onClickSelectArchive(taskArchive.id)">
            <mat-icon
              [matBadge]="taskArchive.processCount"
              matBadgePosition="above before"
              >inventory_2</mat-icon
            >
            @if ((isHandset$ | async) === false) {
              <span style="margin-left: 5px">{{ taskArchive.name }}</span>
            }
          </button>
        }
      }
    </ng-template>
  </mat-menu>
} @else {
  <mat-spinner diameter="24" color="accent"></mat-spinner>
}
